(function ($) {
  'use strict';

  var defaults = {
    callbacks: {
      onClick: null,
    },
  };

  /**
   * SVG elements wrapped in a div for IE compatibility
   * @type {{europe: null}}
   */
  var $maps = {
    europe: null,
  };

  this.SvgMap = function (dataSet, options) {
    /**
     * array of objects
     */
    this.dataSet = dataSet;

    if (options.callbacks) {
      options.callbacks = $.extend({}, defaults.callbacks, options.callbacks);
    }

    this.options = $.extend({}, defaults, options);

    this.$content = null;

    this._popup = new WLCPopup(null, false);
  };

  this.SvgMap.prototype.mapLoader = '<div class="loading loading-after"></div>';

  this.SvgMap.prototype.show = function () {
    var desktop =
      this.options.desktop.prepend +
      '<div class="map-holder">' +
      this.mapLoader +
      '</div>' +
      this.options.desktop.append;
    var mobile =
      this.options.mobile.prepend +
      this.getMobile() +
      this.options.mobile.append;

    this.$content = $(
      '<div class="svg-map"><div class="desktop">' +
        desktop +
        '</div><div class="mobile">' +
        mobile +
        '</div></div>'
    );
    this._popup.setObject(this.$content);

    this._popup.show();

    if (!$maps.europe) {
      $.ajax({
        url: window.ys && window.ys.map && window.ys.map.europe,
        dataType: 'text',
        success: function (data) {
          var $map = $.parseHTML('<div>' + data + '</div>');

          if (!$map || $map.length < 1) {
            console.log('Could not fetch the svg map');
            return;
          }

          $maps.europe = $($map);

          this.generateMap();
        }.bind(this),
      });
    } else {
      this.generateMap();
    }
  };

  this.SvgMap.prototype.generateMap = function () {
    this.$map = $maps.europe;

    if (!this.$map) {
      console.log('The map was not loaded');
      return false;
    }

    $.each(this.dataSet, this.renderMapDataset.bind(this));

    if (this.options.location) {
      var $item = this.$map.find('#' + this.options.location);

      //svg - only select if current geoip country is available in out map
      if ($item.hasClass('available')) {
        $item.addClass('current');
      }
    }

    //using external plugin to render map into
    this.$content.find('.map-holder').html(this.$map.html());

    $('.svg-map input.search').on('keyup', this.search.bind(this));
    $('.svg-map .available').on('click', this.countryClick.bind(this));
  };

  this.SvgMap.prototype.renderMapDataset = function (key, value) {
    //svg - add title tag + class for available countries
    var $item = this.$map.find('#' + key);
    var title = [];
    $.each(value, function (k, o) {
      title.push(o.title);
    });

    //add class to open another popup with links
    if (title.length > 1) {
      $item.addClass('multi');
    }

    $item.addClass('available');
    $item.append('<title>' + title.join(', ') + '</title>');

    return this;
  };

  /**
   * Runs on input change to show filtered items
   */
  this.SvgMap.prototype.search = function (e) {
    var $el = $(e.currentTarget);
    var val = $el.val().toLowerCase();
    var $searchItem = this.$content.find('.search-item');
    this.$content
      .find('.search-item.last-visible-child')
      .removeClass('last-visible-child');

    $searchItem.removeClass('hidden');
    if (val) {
      $searchItem.each(function () {
        var attr = $(this).data('search').toLowerCase();
        if (attr.indexOf(val) < 0) {
          $(this).addClass('hidden');
        }
      });
      this.$content
        .find('.search-item:not(.hidden)')
        .last()
        .addClass('last-visible-child');
    }
  };

  this.SvgMap.prototype.renderSearchItem = function (
    code,
    item,
    currentLocation
  ) {
    var distUrl =
      window.ys && window.ys.dist_url
        ? window.ys.dist_url
        : '/app/themes/skoda-wlc-theme/dist/';
    return (
      '<a href="' +
      item.link +
      '" class="search-item ' +
      (currentLocation === code ? 'current' : '') +
      '" target="_blank" data-search="' +
      code +
      '|' +
      item.title +
      '|' +
      (item.search !== undefined ? item.search : '') +
      '">' +
      '<div class="text">' +
      '<img src="' +
      distUrl +
      'images/flags/' +
      code +
      '.png" />' +
      item.title +
      '</div>' +
      '</a>'
    );
  };

  this.SvgMap.prototype.countryClick = function (e) {
    var $el = $(e.currentTarget);
    var id = $el.attr('id');

    if ($el.hasClass('multi')) {
      var body = '';
      $.each(
        this.dataSet[id],
        function (k, v) {
          body += this.renderSearchItem(id, v);
        }.bind(this)
      );

      var pop = $(
        '<div class="svg-popup"><div class="svg-close">' +
          new WLCIcon('cross_circle') +
          '</div><div class="results">' +
          body +
          '</div></div>'
      );

      if (
        this.options &&
        this.options_callbacks &&
        typeof this.options.callbacks.onClick === 'function'
      ) {
        pop.on(
          'click',
          function (e) {
            this.options.callbacks.onClick(
              id,
              $(e.currentTarget).attr('href'),
              this.options
            );
          }.bind(this)
        );
      }

      this.$content.append(pop);
      this.$content.find('.svg-close').click(function () {
        $(this).closest('.svg-map').find('.svg-popup').remove();
      });
    } else {
      if (
        this.options &&
        this.options.callbacks &&
        typeof this.options.callbacks.onClick === 'function'
      ) {
        this.options.callbacks.onClick(
          id,
          this.dataSet[id][0].link,
          this.options
        );
      }
      var win = window.open(this.dataSet[id][0].link, '_blank');
      win.focus();
    }
  };

  this.SvgMap.prototype.getMobile = function (map) {
    var currentLocation = this.options.location;

    var body =
      '<input placeholder="' +
      this.options.mobile.placeholder +
      '" type="text" value="" class="search" /><div class="results">';

    for (var prop in this.dataSet) {
      if (!this.dataSet.hasOwnProperty(prop)) {
        continue;
      }
      for (var i = 0; i < this.dataSet[prop].length; i++) {
        body += this.renderSearchItem(
          prop,
          this.dataSet[prop][i],
          currentLocation
        );
      }
    }

    body += '</div>';

    return body;
  };
}).bind(window)(jQuery);
